import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  size: PropTypes.number,
};

const CollageIcon = ({ size = 20, ...props }) => (
  <svg
    viewBox="0 0 50 50"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#BFC7D4"
      d="M6.134.329H25V49.67H6.134a5.805 5.805 0 0 1-5.805-5.805V6.134A5.805 5.805 0 0 1 6.134.329z"
    />
    <path
      fill="#FD5750"
      d="M33.327.325h10.961c2.974 0 5.385 2.397 5.385 5.353v6.834H33.327V.325z"
    />
    <path
      fill="#0b7ff4"
      d="M33.327 21.141h16.346v23.162c0 2.966-2.41 5.37-5.385 5.37H33.327V21.142z"
    />
  </svg>
);

CollageIcon.propTypes = propTypes;

export default CollageIcon;
